<template>
	<div class="enterprisewebsite">
		<headerbar :curindex="curindex" v-if="userdata.userType>1"></headerbar>
		<leftnav class="fl" :curindex="15":activenav='"1-4"' v-if="userdata.userType==1"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage">
		<div class="timechaindiv" style="margin-top:10px;">
			<div class="whitebox oh" :class="userdata.userType>1?'centerpage ':''">
				<div class="timechain-title oh w95mg">
					<h2 class="fl title">{{notiontitle}}</h2>
					<span :class="collectdata.collectId == 0?'collectbtn add fr':'collectbtn remove fr'" @click="collectFun()">{{collectdata.collectId == 0?'+添加收藏':'取消收藏'}}</span>
					<!-- <div class="fr">医药健康/大健康</div> -->
				</div>
				<div class="history" v-if="pagedata.length>0">
					<div class="history-date" v-for="list in pagedata" style="position: relative;">
						<h2 class="first"><a href="#nogo">{{list.year}}年</a></h2>
						<ul style="padding-top:80px;"> 
							<li v-for="item in list.children">
								<!-- <h3>{{item.date}}<span>{{list.year}}</span></h3> -->
								<h3>{{item.date}}</h3>
								<dl>
									<dt>
										<span class="a-router title" @click="routerlinkid('/news',item.id,bigclass)">{{item.title}}</span>
										<span :class="item.good > 1?'stargrade1 greenstargrade':'stargrade1 redstargrade'"><i v-for="star in item.star"></i></span>
										</dt> 
								</dl>
							</li>
						</ul>
					</div>
				</div>
			</div>
			</div>
			</div>
		</div>
		<footerbar v-if="userdata.userType>1"></footerbar>
	</div>
</template>

<script>
	export default {
		name: 'eventlian',
		data() {
			return {
				msg: "事件链",
				notiontitle: '',
				pagetypes: 1,
				bigclass: 3007,
				curindex: 2,
				echainid: 0,
				pagedata: [],
				collectdata:[],
				chaindata: [{
						id: 279,
						title: "国内首部《低慢小无人机探测反制系统通用要求》团体标准在深圳正式发布。",
						publishTime: "2021-10-29",
						stockCode: "",
						good: 1
					},
					{
						id: 282,
						title: "行业首个！迅蚁、美团、航科院联合起草的城市物流无人机系统相关技术标准即将面世。",
						publishTime: "2021-09-28",
						stockCode: "",
						good: 1
					},
					{
						id: 283,
						title: "北航、华为、中国移动共同研发的“5G 彩云一号”无人飞艇试飞成功，成为全国首个通过无人飞艇搭载5G基站的成功案例。",
						publishTime: "2021-09-14",
						stockCode: "",
						good: 1
					},
					{
						id: 284,
						title: "美团联合深圳地铁、万科打造的全球首个无人机配送商圈将落地深圳。",
						publishTime: "2021-07-30",
						stockCode: "",
						good: 1
					},
					{
						id: 285,
						title: "大疆创新发布新品无人机御 Mavic Air 2。",
						publishTime: "2021-04-28",
						stockCode: "",
						good: 1
					},
					{
						id: 286,
						title: "美国允许小型无人机飞越人群上空和夜间飞行的规定生效，这是美国向无人机最终广泛用于商业运输迈出的重要一步。",
						publishTime: "2021-04-21",
						stockCode: "",
						good: 1
					},
					{
						id: 290,
						title: "美团拟寻求以配售和可换股债券方式融资100亿美元，大力开投入无人车和无人机送餐等新业务。",
						publishTime: "2021-04-20",
						stockCode: "",
						good: 1
					},
					{
						id: 291,
						title: "美国火星无人机“机智号”成功在火星耶泽罗撞击坑完成首飞，这是人类首次在地球以外的大气层内完成动力飞行。",
						publishTime: "2021-04-19",
						stockCode: "",
						good: 1
					},
					{
						id: 292,
						title: "纵横股份联合中国移动（成都）产业研究院，发布全新纵横大鹏5G网联无人机解决方案。",
						publishTime: "2020-04-10",
						stockCode: "",
						good: 1
					},
					{
						id: 293,
						title: "“天九一号”载人智能无人机在四川苍溪卢家湾成功首飞。",
						publishTime: "2019-03-29",
						stockCode: "",
						good: 1
					},
				],
			}
		},
		watch: {

		},
		created() { 
			this.getuserinfor();
			this.getpagelist(); 
		},
		mounted() {

		},
		methods: {
			getuserinfor() {
				this.bus.$emit('loading',true);
				let dataddd = sessionStorage.getItem('userData') ? sessionStorage.getItem('userData') : localStorage
					.getItem('userData');
				if (typeof(dataddd) == 'object') {
					this.userdata = dataddd;
				} else {
					this.userdata = JSON.parse(dataddd);
				}
				this.echainid = this.$route.query.id;
				this.pagetypes = this.$route.query.type * 1;
				if (this.pagetypes == 1) {
					this.bigclass = 30007;
					this.msg = "行业大事件链";
				} else if (this.pagetypes == 2) {
					this.bigclass = 30008;
					this.msg = "行业政策链";
				}
			},
			getpagelist() {
				var _this = this;
				this.$axios.get(this.$api.cyl.news.list() + "?type=2&pageSize=100&bigClass=" + this.bigclass + "&notionList=" + this.echainid, {
						headers: {
							AuthToken: this.userdata.token
						}
					}).then(function(res) {
					console.log(res.data); 
					_this.collectdata=res.data.data;
					if(res.data.list.length>0){
						_this.notiontitle = res.data.list[0].notion + "-" + _this.msg;
						document.title = res.data.list[0].notion + "-" + _this.msg;
						_this.turndatatype(res.data.list);
						_this.bus.$emit('loading',false);
					} 
				})
			},
			turndatatype(datalist) {
				for (var i = 0; i < datalist.length; i++) {
					datalist[i].year = datalist[i].publishTime.substring(0, 4) * 1;
					datalist[i].date = datalist[i].publishTime.substring(5, datalist[i].publishTime.length);
					datalist[i].haseach = true;
				};
				var newdatelist = [{
					year: datalist[0].year,
					children: [datalist[0]]
				}];;
				datalist[0].haseach = false;
				for (var i = 0; i < datalist.length; i++) {
					var d=i+1; 
					if(d > datalist.length -1){d=datalist.length -1 }
					if(datalist[i].year == datalist[d].year && datalist[d].haseach){
						newdatelist[newdatelist.length - 1].children.push(datalist[d]);
					}else if (datalist[i].year != datalist[d].year && datalist[d].haseach){
								newdatelist.push({
									year: datalist[d].year,
									children: [datalist[d]]
								});
					} 
					datalist[d].haseach = false;  
				} 
				// console.log(datalist)
				console.log('newdata0',datalist, newdatelist);
				this.pagedata = newdatelist; 
			},
			//添加删除收藏
			collectFun(){
				// console.log(this.pagedata.collectId,this.pagedata.collectType);
				var _this=this,cid=this.collectdata.collectId;
				var ajaxurl="",ajaxdata={};
				if(cid == 0){
				 ajaxurl=this.$api.cyl.collect.add();
					ajaxdata={type:this.collectdata.collectType,id:this.echainid}
					}else{
						ajaxurl=this.$api.cyl.collect.remove();
						ajaxdata={collectId:this.collectdata.collectId};
					} 
					console.log(ajaxurl,ajaxdata);
				$.ajax({
					type:"POST",
					url:ajaxurl,
					data:ajaxdata,
					headers:{AuthToken:this.userdata.token },
					success:function(res){ 
						console.log(res);
						if(res.success){
							if(cid == 0){
								_this.collectdata.collectId=res.data.collectId;
							}else{
								_this.collectdata.collectId=0;
							} 
						} 
					} 
				}) 
			},


		}
	}
</script>

<style scoped="scoped">
	@import url("../../../../assets/css/history.css");
	/* @import url("../../../assets/css/H-ui.reset.css"); */
</style>
